import SkeletonTable from './SkeletonTable'


export default SkeletonTable